/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateInChatPromptRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_inchat_prompts.pb'
import {UpdateInChatPromptResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_inchat_prompts.pb'


export const updateInChatPrompt = (request: UpdateInChatPromptRequest, options?: CashRequestOptions) => post<UpdateInChatPromptRequest, UpdateInChatPromptResponse>("/cash-app/goose-cash/v3/update-inchat-prompt", request, {...options, rejectOnError: true })